/* eslint-disable */
export default {
  matched: 'Appariés',
  other: 'Autre',
  associated: 'Associé',
  foundFromServer: 'Trouvé à partir de {appName}',
  recently: 'Récent',
  additionalLabelAccount: 'Compte : {displayName}',
  additionalLabelContact: 'Contact : {displayName}',
  notFound: 'S.O.',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
